import * as React from "react";

import { SupplyType, SupplyTypeLabel } from "../../../../types/index";
import ToggleButtonGroup from "../../../ToggleButtonGroup";

interface Props {
  supplyTypeFilterState: SupplyType | null;
  onChange: (filter: SupplyType | null) => void;
  disabled?: boolean;
}

class SupplyTypeOptions extends React.Component<Props> {
  private isSupplyOptionSelected = (filter: SupplyType | null): boolean =>
    this.props.supplyTypeFilterState === filter;

  private buttonsSupplyType = [
    {
      label: "Alle",
      selected: () => this.isSupplyOptionSelected(null),
      onClick: () => this.props.onChange(null),
    },
    {
      label: SupplyTypeLabel.gv,
      selected: () => this.isSupplyOptionSelected(SupplyType.GV),
      onClick: () => this.props.onChange(SupplyType.GV),
    },
    {
      label: SupplyTypeLabel.sv,
      selected: () => this.isSupplyOptionSelected(SupplyType.SV),
      onClick: () => this.props.onChange(SupplyType.SV),
    },
  ];

  public render() {
    return (
      <ToggleButtonGroup
        title="Versorgungsart"
        buttons={this.buttonsSupplyType}
        disabled={this.props.disabled}
      />
    );
  }
}

export default SupplyTypeOptions;



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/FilterOptions/SupplyTypeOptions.tsx